import { obsDatetimeState, serverTimeState } from "libs/atoms";
import { useRecoilValue } from "recoil";

const ServerClock = () => {
  const serverTime = useRecoilValue(obsDatetimeState);

  if (!serverTime) return null;

  return <div>
    <span>{serverTime[5].date}</span>
    <span>{serverTime[5].time}</span>
  </div>
}

export default ServerClock;